// extracted by mini-css-extract-plugin
module.exports = {"toggleButtons":"VariableDialog_toggleButtons__3qOtJ"};